import { render, staticRenderFns } from "./publicItem.vue?vue&type=template&id=0fdeaed1&scoped=true&"
import script from "./publicItem.vue?vue&type=script&lang=js&"
export * from "./publicItem.vue?vue&type=script&lang=js&"
import style0 from "./publicItem.vue?vue&type=style&index=0&id=0fdeaed1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdeaed1",
  null
  
)

export default component.exports